<template>
  <div id="page-mail-sent-failed-list" class="vx-card p-6">

    <!--      Search area-->
    <vx-card ref="filterCard" @keyup.enter="pressEnterSearch" id="mail_sent_failed_filters" tabindex="0" title="" class="mail-sent-failed-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">

      <div class="vx-row">
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせ ﾊﾟﾀｰﾝ</label>
          <v-select class="w-full"
                    id="mail_type_search"
                    v-model="mail_type_search"
                    :options="listMailTypeSelect"
                    @input="clearFocusTypeDropdown()">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">方法</label>
          <v-select class="w-full"
                    id="inquiry_type_search"
                    v-model="inquiry_type_search"
                    :options="listInquiryTypeSelect"
                    @input="clearFocusTypeDropdown()">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">送信日時</label>
          <flat-pickr id="sent_date_search"
                      class="w-full flatpickr-style"
                      v-model="sent_date_search"
                      placeholder="..."
                      :config="configDate"
                      @on-change="clearFocusTypeDropdown()">
          </flat-pickr>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせID</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="receive_mail_id_search"
                    v-model="receive_mail_id_search"
                    icon-after="true" :icon="receive_mail_id_search ? iconVsInput : ''">
          </vs-input>
        </div>
        
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">担当者</label>
          <v-select :class="checkIsMultiple.mst_user ? 'w-full show-feature-x' : 'w-full'"
                    id="mst_user_search"
                    v-model="mst_user_search"
                    :options="listMstUserSelect"
                    placeholder="..."
                    :multiple="checkIsMultiple.mst_user"
                    :close-on-select="false"
                    @input="selectionChangedvSelect(); clearFocusTypeDropdown();"
                    @open="openvSelect"
                    :deselectFromDropdown="true"
                    :reduce="listMstUserSelect => listMstUserSelect.value">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">状態</label>
          <v-select :class="checkIsMultiple.state_flg ? 'w-full show-feature-x' : 'w-full'"
                    id="state_flg_search"
                    v-model="state_flg_search"
                    :options="listSendMailSelectStateFlag"
                    placeholder="..."
                    :multiple="checkIsMultiple.state_flg"
                    :close-on-select="false"
                    @input="selectionChangedvSelect(); clearFocusTypeDropdown();"
                    @open="openvSelect"
                    :deselectFromDropdown="true"
                    :reduce="listSendMailSelectStateFlag => listSendMailSelectStateFlag.value">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">種別</label>
          <v-select :class="checkIsMultiple.type ? 'w-full show-feature-x' : 'w-full'"
                    id="type_search"
                    v-model="type_search"
                    :options="listTypeSelect"
                     placeholder="..."
                    :multiple="checkIsMultiple.type"
                    :close-on-select="false"
                    @input="selectionChangedvSelect(); clearFocusTypeDropdown();"
                    @open="openvSelect"
                    :deselectFromDropdown="true"
                    :reduce="listTypeSelect => listTypeSelect.value">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">タイトル</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="subject_search"
                    v-model="subject_search" icon-after="true" :icon="subject_search ? iconVsInput : ''">
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">本文</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="body_search"
                    v-model="body_search" icon-after="true" :icon="body_search ? iconVsInput : ''">
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full"></div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full"></div>
        <div class="vx-col flex flex-wrap justify-end m-auto mb-0 pt-2 lg:w-1/4 sm:w-1/2 w-full">
          <vs-button icon="search" @click="onSearch(true)" color="primary" class="ml-2">検索 </vs-button>
        </div>
      </div>
    </vx-card>

    <div class="flex flex-wrap items-center">
      <vs-row class="pb-2"
              style="align-items: center; justify-content: space-between;"
              vs-type="flex">
        <vs-col vs-w="4" class="flex items-center">
          <vs-col style="width: 111px" class="mr-3">
            <vs-switch v-model="modeComputed">
              <span slot="on">プレビュー</span>
              <span slot="off">プレビュー非表示</span>
            </vs-switch>
          </vs-col>
          <vs-col style="width: 200px" class="flex items-center justify-center">
            <div style="width: 35%;">
              表示件数:
            </div>
            <div style="width: 60%">
              <v-select class="square mr-2"
                        id="pagination_limit"
                        v-model="pagination.limit"
                        placeholder="..."
                        :options="listRowLimit"
                        :searchable="false">
              </v-select>
            </div>
          </vs-col>
        </vs-col>
        <vs-col vs-w="8"></vs-col>
      </vs-row>
    </div>

    <!-- AgGrid Table -->
    <div v-if="!modeComputed">
      <ag-grid-vue
          id="myGrid"
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table database"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="listMailSentFailedComputed"
          rowSelection="single"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          :domLayout="domLayout"
          :paginationPageSize="paginationPageSize"
          @sort-changed="onSortChanged"
          @grid-ready="onGridReady"
          @selection-changed="onSelectionChanged"
          :enableRtl="$vs.rtl"
          :overlayNoRowsTemplate="noRowsTemplate"
          :suppressPaginationPanel="true"
          :detailRowAutoHeight="true">
      </ag-grid-vue>
      <div style="position: relative">
      <!-- ITEMS PER PAGE -->
      <div>
        <div class="flex items-center justify-between">
          <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
        </div>
      </div>
      <vs-pagination
          v-if="listMailSentFailed.length > 0"
          :total="pagination.totalPage"
          :max="7"
          v-model="pagination.currentPage"
          class="pt-10 pr-10"
      />
      </div>
    </div>

    <!--Preview mode-->
    <vs-row v-else vs-type="flex" vs-justify="space-between">
      <vs-col vs-w="4">
        <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table database overflow-y-auto ag-grid-customize"
            :columnDefs="previewModeColumnDefs"
            :defaultColDef="defaultColDef"
            :rowData="listMailSentFailedComputed"
            rowSelection="single"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            :domLayout="domLayout"
            :paginationPageSize="paginationPageSize"
            :isRowSelectable="() => true"
            @sort-changed="onSortChanged"
            @grid-ready="onGridReady"
            @selection-changed="onPreviewModeSelectionChanged"
            :enableRtl="$vs.rtl"
            :overlayNoRowsTemplate="noRowsTemplate"
            :suppressPaginationPanel="true"
            :detailRowAutoHeight="true"
            :getRowHeight="getRowHeight"
            :isFullWidthCell="isFullWidthCell"
            :fullWidthCellRenderer="fullWidthCellRenderer"
            style="max-height: 960px;"
            >
        </ag-grid-vue>

        <div style="position: relative">
          <!-- ITEMS PER PAGE -->
            <div>
                <div class="flex items-center justify-between">
                  <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
                </div>
            </div>
            <vs-pagination
              v-if="listMailSentFailed.length > 0"
              :total="pagination.totalPage"
              :max="7"
              v-model="pagination.currentPage"
              class="pt-10 pr-10"
            />
        </div>
      </vs-col>

      <!--Preview section-->
      <vs-col vs-w="7.75" id="receive-mail-detail" >
        <vs-row class="mt-5  py-2"
                vs-type="flex"
                vs-align="flex-end"
                vs-justify="flex-end">
              <vs-button class="square"
                    color="#4478b8"
                    @click="editMailDetail"
                    :disabled="!preview_detail.id"
                    >
                <span><feather-icon icon="EditIcon" class="cursor-pointer" svg-classes="h-6 w-6"></feather-icon></span>
              </vs-button>
        </vs-row>
        <vs-row>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>方法</span>
                  </div>
                </template>
                <vs-input readonly class="disabled-input" v-model="preview_detail.inquiry_type_text" placeholder="" />
              </vx-input-group>
          </vs-col>
          <vs-col>
              <vx-input-group class ="square" type="file">
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>種別</span>
                  </div>
                </template>
                <vs-input readonly class="disabled-input" v-model="preview_detail.type_text" placeholder="" />
              </vx-input-group>
            </vs-col>
          <vs-col>
              <vx-input-group class ="square">
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>担当者</span>
                  </div>
                </template>
                <vs-input readonly class="disabled-input" v-model="preview_detail.mst_user" placeholder="" />
              </vx-input-group>
            </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>From</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.email_sender" placeholder="" />
              </vx-input-group> 
            </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>To</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.to" />
              </vx-input-group> 
          </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>CC</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.cc" />
              </vx-input-group> 
          </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>BCC</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.bcc" />
              </vx-input-group> 
          </vs-col>
          <vs-col class="mt-5">
            <div class="prepend-text label-style w-full" style="padding:10px">
              <span>エラー内容</span>
            </div>
            <vx-card
              class="card-body-mail disabled-input"
              no-radius
              cardBorder
            >
              <div
                class="w-full"
                v-html="preview_detail.error_detail"
                style="height: 150px; overflow-y: scroll"
              ></div>
            </vx-card>
          </vs-col>
          <vs-col class="mt-5" style="border: solid 1px #E2E2E2">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text label-style" style="width: 120px">
                  <span>添付ファイル</span>
                </div>
              </template>
              <vs-row>
                <vs-col
                  style="width: max-content; padding: 3px 5px"
                  :key="index"
                  v-for="(value, index) in preview_detail.attachmentFileName"
                >
                  <div @click="downloadAttachment(value.path)">
                    <vs-chip
                      style="cursor: pointer"
                      class="mt-1"
                      color="dark"
                      transparent
                      >{{ value.file_name }}</vs-chip
                    >
                  </div>
                </vs-col>
              </vs-row>
            </vx-input-group>
          </vs-col>
        </vs-row>

        <vs-row class="mt-6">
          <vx-card
            class="card-body-mail disabled-input"
            no-radius
            cardBorder
            noShadow
            title="件名"
          >
            <div
              class="w-full"
              v-html="preview_detail.subject"
              style="padding: 9.8px"
            ></div>
          </vx-card>

          <vx-card
            class="card-body-mail disabled-input"
            no-radius
            cardBorder
            noShadow
            title="お問い合わせ本文"
          >
            <div
            id="previewDetailBodyBlock"
              class="pl-2 pt-2"
              v-if="!preview_detail.body_type || preview_detail.body_type == 0"
              v-html="cleanedBodyPreviewDetail"
              style="height: 300px; overflow-y: scroll"
            ></div>
            <vs-textarea
            id="previewDetailBodyTextarea"
              v-else
              readonly
              v-model="preview_detail.body"
              placeholder="..."
              height="300px"
            />
          </vx-card>
        </vs-row>
      </vs-col>

      
    </vs-row>

    <!-- dialog contact list -->
    <Contacts
      :activeModelContacts="activeModelContacts"
      :typeModalContact="typeModalContact"
    >
    </Contacts>

        <!-- Create Dialog -->
      <vs-popup id="dialogMailDetail" title="メール明細" :active.sync="activePopUp" button-close-hidden>
          <div class="mail-from-to">
            <vs-row class="flex-wrap items-center justify-star row-email">
              <vs-col vs-w="1">
                  <span class="block leading-none pl-2">方法</span>
              </vs-col>
              <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                <v-select class="w-full" v-if="!readOnly"
                    id="inquiryType"
                    v-model="inquiryType"
                    :options="listInquiryTypeSelect"
                    :searchable="false">
              <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
                </v-select>
                <input v-else v-model="inquiryType.label" disabled class="w-full pl-2 background_color__white"/>
              </vs-col>
            </vs-row>
            <vs-row class="flex-wrap items-center justify-star row-email">
              <vs-col vs-w="1">
                <span class="block leading-none pl-2">種別</span>
              </vs-col>
              <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                <v-select class="w-full" v-if="!readOnly"
                          id="type"
                          v-model="type"
                          :options="listTypeSelect"
                          :searchable="false">
                  <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
                </v-select>
                <input v-else v-model="type.label" disabled class="w-full pl-2 background_color__white"/>
              </vs-col>
            </vs-row>
            <vs-row class="flex-wrap items-center justify-star row-email">
              <vs-col vs-w="1">
                <span class="block leading-none pl-2">担当者</span>
              </vs-col>
              <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                <v-select class="w-full" v-if="!readOnly"
                          id="type"
                          v-model="mst_user"
                          :options="listMstUserSelect"
                          :searchable="false">
                  <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
                </v-select>
                <input v-else v-model="mst_user.label" disabled class="w-full pl-2 background_color__white"/>
              </vs-col>
            </vs-row>
            <vs-row class="flex-wrap items-center justify-star row-email">
              <vs-col vs-w="1">
                  <span class="pl-2">From</span>
              </vs-col>
              <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                <v-select class="w-full"
                        v-if="!readOnly"
                        id="from"
                        v-model="mailFrom"
                        :options="listMailFrom"
                        :searchable="false">
                <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
              </v-select>
              <input v-else v-model="mailFrom" class="w-full pl-2" readonly/>
              </vs-col>
            </vs-row>
            <vs-row class="flex-wrap items-center justify-start row-email">
              <vs-col vs-w="1">
                  <span class="pl-2">To</span>
              </vs-col>
              <vs-col id="tags-to" vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail" style="position: relative;">
                <vs-chips v-model="listMailTo" :class="{'pointer-events-none': readOnly}" class="w-full vschipsContacts" ref="vsChipTo" id="vschipsTo">
                  <vs-chip v-for="(to, index) in listMailTo" 
                           :key="to+index" :id="'tag-to-'+ index" 
                           :closable="!readOnly" 
                           :color="validateEmail(to)?'dark':'danger'" 
                           transparent 
                           @click="listMailTo.splice(index,1), sendlistMailTo.splice(index,1)"
                           >
                    {{to | convertEmail}}
                  </vs-chip>
                </vs-chips>
                <ul class="w-full rounded-b-lg" id="contacts_dropdown" style="z-index: 100000; position: absolute !important; background-color: #FFFFFF; top: 38px; border-bottom: 3px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; padding-bottom: 5px;">
                  <li v-for="(to, index) in listContactComputed" @click="contactSelected(to.mail_address,'TO')" class="cursor-pointer contact-li">{{ to.mail_address }}</li>
                </ul>
                <feather-icon v-show="showIconContacts" icon="BookOpenIcon" class="cursor-pointer z-100" @click="showListContact('TO')" style="position: absolute !important; right: 17px;"/>
              </vs-col>
            </vs-row>
            <vs-row class="flex-wrap items-center justify-start row-email">
              <vs-col vs-w="1">
                  <span class="pl-2">CC</span>
              </vs-col>
              <vs-col id="tags-cc" vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail" style="position: relative;">
                <input v-if="cc != null" v-model="cc" id="ccc" class="w-full pl-2"/>
                <vs-chips v-else :class="{'pointer-events-none': readOnly}" v-model="listMailCC" class="w-full vschipsContacts" ref="vsChipCc" id="vschipsCc">
                  <vs-chip v-for="(cc, index) in listMailCC" :key="cc+index" :id="'tag-cc-'+ index" :closable="!readOnly" :color="validateEmail(cc)?'dark':'danger'" transparent @click="listMailCC.splice(index,1), sendlistMailCC.splice(index,1)">
                    {{cc | convertEmail}}
                  </vs-chip>
                </vs-chips>
                <ul class="w-full rounded-b-lg" id="contacts_dropdown_cc" style="z-index: 100000; position: absolute !important; background-color: #FFFFFF; top: 38px; border-bottom: 3px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; padding-bottom: 5px;">
                  <li v-for="(to, index) in listContactComputed" @click="contactSelected(to.mail_address,'CC')" class="cursor-pointer contact-li">{{ to.mail_address }}</li>
                </ul>
                <feather-icon v-show="showIconContacts" icon="BookOpenIcon" class="cursor-pointer z-100" @click="showListContact('CC')" style="position: absolute !important; right: 17px;"/>
              </vs-col>
            </vs-row>
            <vs-row class="flex-wrap items-center justify-start row-email">
              <vs-col vs-w="1">
                  <span class="pl-2">BCC</span>
              </vs-col>
              <vs-col id="tags-bcc" vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail" style="position: relative;">
                <input v-if="bcc != null" v-model="bcc" id="bccc" class="w-full pl-2"/>
                <vs-chips v-else :class="{'pointer-events-none': readOnly}" v-model="listMailBCC" class="w-full vschipsContacts" ref="vschipBcc" id="vschipsBcc">
                  <vs-chip v-for="(bcc, index) in listMailBCC" :key="bcc+index" :id="'tag-bcc-'+ index" :closable="!readOnly" :color="validateEmail(bcc)?'dark':'danger'" transparent @click="listMailBCC.splice(index,1)">
                    {{bcc | convertEmail}}
                  </vs-chip>
                </vs-chips>
                  <ul class="w-full rounded-b-lg" id="contacts_dropdown_bcc" style="z-index: 100000; position: absolute !important; background-color: #FFFFFF; top: 38px; border-bottom: 3px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; padding-bottom: 5px;">
                    <li v-for="(to, index) in listContactComputed" @click="contactSelected(to.mail_address,'BCC')" class="cursor-pointer contact-li">{{ to.mail_address }}</li>
                  </ul>
                  <feather-icon v-show="showIconContacts" icon="BookOpenIcon" class="cursor-pointer z-100" @click="showListContact('BCC')" style="position: absolute !important; right: 17px;"/>
                </vs-col>
            </vs-row>
          </div>
          
          <!-- error detail -->
          <div class="pt-10 card-subject">
            <div class="flex-wrap items-center justify-start card-title">
              <span class="pl-2">エラー内容</span>
            </div>
            <div>
              <div  class="w-full div-subject" style="height: 100px; overflow-y: scroll" v-html="errorDetail"></div>
            </div>
          </div>

          <!-- file -->
          <div class="mt-10 card-file-input">
            <vs-row class="flex-wrap justify-start items-center row-card-file">
              <vs-col vs-w="1.5" class="card-title">
                <span class="pl-2">添付ファイル</span>
              </vs-col>
              <vs-col vs-w="1.75" class="flex flex-wrap items-center justify-start input-tag-file">
                <div class="pl-2" >
                  <input type="file" multiple ref="files" v-on:change="handleFiles" style="display: none"/>
                  <vs-button :disabled="readOnly" color='darkgray' @click="$refs.files.click()">ファイル選択</vs-button>
                </div>
              </vs-col>
              <vs-col vs-w="8.75">
                <div style="display: inline-block" v-for="(file, index) in Object.values(files)" :key="index" :class="{'cursor-pointer':readOnly}">
                  <vs-chip class="mt-1 mr-1" color="dark" transparent :closable="!readOnly" @click="removeFile(index)">{{file.file_name.split('/').reverse()[0] | convertFileNameSend}}</vs-chip>
                </div>
              </vs-col>
            </vs-row>
          </div>

          <!-- body, subject -->
          <div class="pt-10 card-subject">
            <div class="flex-wrap items-center justify-start card-title">
              <span class="pl-2">件名</span>
            </div>
            <div>
              <vs-textarea v-if="!readOnly" v-model="mailSubject"></vs-textarea>
              <div v-else class="w-full div-subject" v-html="mailSubject"></div>
            </div>
            <div class="card-title">
              <span class="pl-2">メール本文</span>
            </div>
            <div class="div-show-receive-mail">
              <v-select class="float-right relative z-10 rounded cursor-pointer"  @input="changeModeHTML"  :reduce="bodyType => bodyType.value" :value="modeHTML" label="label" :options="bodyType"></v-select>
              <vue2-tinymce-editor id="tinymceMessageSendFailed"  @editorInit="onEditorInit" :disabled="readOnly" :class="{'pointer-events-none': readOnly}" v-model="mailMessage" v-if="modeHTML" :options="editorOption"></vue2-tinymce-editor>
              <vs-textarea id="textMessage"  ref="textMessage" class="text-Message" :disabled="readOnly" v-else v-model="mailMessage" placeholder="" height='200px'></vs-textarea>
            </div>

            <div style="display: flex; justify-content: flex-end" class="pt-4">
              <vs-button @click="beforeSendMail" :disabled="readOnly || !mailFrom" icon="send" color="success" style="padding: 8px; margin-right: 5px;height: 37px">再送</vs-button>
              <vs-button @click="activePopUp = false" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
            </div>
          </div>
      </vs-popup>

      <!-- dialog confirm send: no subject, content -->
      <vs-popup id="dialogSend" style="z-index:99999" :title="titleDialogSend" :active.sync="activeSend" button-close-hidden>
        <div>
          <span>
            {{confirmQuestionSend}}
          </span>
        </div>
        <div class="flex justify-end mt-4">
            <vs-button @click="confirm" icon="check" color="success" class="mx-2">はい</vs-button>
            <vs-button @click="activeSend = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
        </div>
      </vs-popup>

      <!-- dialog confirm changeMode HTML-->
      <vs-popup ref="dialogConfirm" style="z-index:99999" title="テキストモードに切り替え" :active.sync="activeChangeModeHTML" button-close-hidden>
        <div>
          <span>
            テキストモードに切り替えると、このメッセージのすべての書式設定とインライン画像が削除されます。
          </span>
          <br>
          <span>続けますか？</span>
        </div>
        <div class="flex justify-end">
            <vs-button @click="modeHTML = false;activeChangeModeHTML = false" color="success" icon="check" style="padding: 8px; margin-right: 5px;height: 37px">はい</vs-button>
            <vs-button @click="activeChangeModeHTML = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">キャンセル</vs-button>
        </div>
      </vs-popup>
  </div>
</template>
<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Japanese} from 'flatpickr/dist/l10n/ja.js';
import {mapActions, mapGetters, mapMutations} from 'vuex'
import {getMaximumSizeAttachment} from '../utils/settings';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import htmlToFormattedText  from 'html-to-formatted-text';
import {Html5Entities} from "html-entities";
import {convertInquiryTypeToText, convertMailTypeToText, handleDownloadAttachment, setupIconClickEvent, tinymceOptions, setupLanguageTinymce, focusAtBrLine, convertLineBreakBody} from "@/utils/helpler-utils";
import Contacts  from '../components/Contacts.vue';
import EventBus from "../EventBus";


export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    Vue2TinymceEditor,
    htmlToFormattedText,
    Html5Entities,
    Contacts
  },
  data () {
    return {
      iconVsInput: 'close', 
      bodyType : [
        {
          label : 'Text 形式',
          value : false
        },
        {
          label : 'HTML 形式',
          value : true
        }
      ],
      isCreated: true,
      sent_date_search: '',
      mail_type_search: {
        label: '...',
        value: ''
      },
      receive_mail_id_search: '',
      mst_user_search: {
        value: '',
        label: '...'
      },
      state_flg_search: {
        value: '',
        label: '...'
      },
      inquiry_type_search:  {
        value: '',
        label: '...'
      },
      subject_search: '',
      body_search: '',
      type_search: {
        value: '',
        label: '...'
      },
      configDate: {
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: ''
      },
      listSentUserNameSelect: [
        '...'
      ],
      listMstUserSelect: [
        {
          label: '...',
          value: ''
        }
      ],
      listMailTypeSelect: [
        {
          label: '...',
          value: ''
        },
        {
          label: '直接お問い合わせ',
          value: '0'
        },
        {
          label: '返信メール',
          value: '1'
        },
      ],
      listInquiryTypeSelect: [
        {
          label: '...',
          value: ''
        },
        {
          label: 'メール',
          value: '0'
        },
        {
          label: '電話',
          value: '1'
        },
        {
          label: '営業',
          value: '2'
        },
        {
          label: 'その他',
          value: '9'
        },
      ],
      listSendMailSelectStateFlag : [
        {
          label: '...',
          value: ''
        },
        {
          value: 0,
          label: '下書き'
        },
        {
          value: 1,
          label: '送信済'
        },
        {
          value: 2,
          label: '送信失敗'
        },

      ],
      to: null,
      cc: null,
      bcc: null,
      listTypeSelect: [
        '...'
      ],

      startRow: 0,
      endRow: 0,
      pagination: {
        totalPage: 0,
        currentPage: this.searchFilter && this.searchFilter.queries && this.searchFilter.queries.page  ? this.searchFilter.queries.page:1,
        limit: 10,
        totalItem: 0,
        from: 1,
        to: 10
      },
      orderBy: 'sent_datetime',
      orderDir: 'desc',

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: 'autoHeight',
      gridApi: null,
      columnApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
      },
      columnDefs: [
        {
          headerName: '方法',
          field: 'inquiry_type_text',
          width: 75,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '送信日時',
          field: 'sent_datetime',
          width: 150,
          unSortIcon: true,
          sort: 'desc',
          suppressMovable: true,
        },
        {
          headerName: 'お問い合わせID',
          field: 'receive_mail_id',
          width: 325,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '担当者',
          field: 'full_name',
          width: 150,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '状態',
          field: 'state_flg_text',
          width: 130,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '種別',
          field: 'type_text',
          width: 100,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'タイトル',
          field: 'subject',
          width: 300,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'メール本文',
          field: 'body',
          width: 300,
          unSortIcon: true,
          suppressMovable: true,
        },
      ],
      // Cell Renderer Components
      components: {
      },
      //CheckMultiple v-Select
      checkIsMultiple: {
        state_flg: false,
        mst_user : false,
        type     : false,
      },
      listSettings: [],
      listMailSentFailed: [],
      activePopUp: false,
      readOnly: false,
      //Detail Mail Failed
      idMailFailed: null,
      inquiryType: {},
      type: {},
      mst_user: {},
      listMailFrom: [],
      mailTo: '',
      mailCC: '',
      mailBCC: '',
      mailFrom: '',
      listMailTo: [],
      listMailCC: [],
      listMailBCC: [],
      sendlistMailTo: [],
      sendlistMailCC: [],
      files: [],
      mailSubject: '',
      errorDetail: '',
      tinymceEditor: null,
      editorOption: tinymceOptions,
      mailMessage: '',
      modeHTML        : false,
      activeChangeModeHTML: false,
      canChangeMessage: false,
      replyMailID: null,
      messageError: '',
      //dialog confirm mail-send without body or subject
      activeSend: false,
      confirmQuestionSend: '',
      titleDialogSend: '',
      totalConfirmTime: 0,
      //Preview Mode
      previewModeColumnDefs: [
        {
          headerName: "",
          field: "id",
          width: 200,
          unSortIcon: true,
          suppressMovable: true,
        },
      ],
      getRowHeight: null,
      fullWidthCellRenderer: null,
      isFullWidthCell: null,
      selectedPreviewMail: {},
      activePreviewPopUp: false,
      activeModelContacts: false,
      typeModalContact:'',
      showIconContacts: false,

      //PAC_21-91
      listRowLimit: [
        '10',
        '25',
        '50'
      ]
    }
  },
  watch: {
    'pagination.limit': function () {
      this.pagination.currentPage = 1;
      this.onSearch(false);
    },
    async $route (to, from){
      /* start loading with many requests */
      this.$store.dispatch('updateLoads', true)
      this.clearSearchFilter()
      let mailBox = this.$route.params.email;
      if (mailBox){

      }else if (this.listMailBox && this.listMailBox.length > 0) {
        mailBox = this.listMailBox[0].receive_user_name
      }
      if (mailBox) {
        this.setDefaultSearchOption()
        this.orderBy = 'sent_datetime'
        this.orderDir = 'desc'
        this.gridApi.setSortModel({colId: 'sent_datetime', sort: 'desc'})
        await this.getListMstUserSelect()
        await this.getListMailBox()
        await this.getListKindsSelect()
        this.readOnly = await this.setUserReadOnly(mailBox) > 0;
        if (!this.readOnly){
          const listMailBox = await this.getListMailBoxSend();
          listMailBox.filter( item =>{
            this.listMailFrom.push(item.sent_user_name);
          })
          const setting = await this.getListSettings();
          if (setting){
            this.listSettings = [];
            setting.map(element => this.listSettings.push(element));
          }
        }
        await this.onSearch(true, mailBox)
      }

      /* stop loads */
      this.$store.dispatch('updateLoads', false)
    },
    inquiry_id_search(val){
      if(val < 0) return this.inquiry_id_search = null
    },
    'pagination.currentPage':{
      deep: true,
      immediate: true,
      handler: function(val){
        if(!this.isCreated) this.paginationPage(val)
      }
    },
    activePopUp() {
      if (!this.activePopUp) {
        if (!this.activePreviewPopUp) this.gridOptions.api.deselectAll();
        else this.activePreviewPopUp = false;
      }
    },
    modeHTML(){
      if (this.canChangeMessage){
        this.changeMessage();
      }
    },
    listMailTo(newVal, oldVal) {
      newVal.forEach(value => {
        let emailExists = this.sendlistMailTo.some(function(emailto) {
          if (emailto.includes(value)) {
            return true;
          }
        });
        if (!emailExists) {
          this.sendlistMailTo.push(value);
        }
      });
      let listMailToUpdate = this.listMailTo.filter(item => {
        return (item !== '' && item !== ' ')
      })
      if (listMailToUpdate.length !== this.listMailTo.length) {
        this.listMailTo = listMailToUpdate
      }
      this.$refs.vsChipTo.newChip = "";
      this.$nextTick(() => {
        let vschipsTo = document.getElementById('vschipsTo').clientHeight;
        document.getElementById('contacts_dropdown').style.top = vschipsTo + 'px';
      });
    },
    listMailCC(newVal, oldVal) {
      newVal.forEach(value => {
        let emailExists = this.sendlistMailCC.some(function(emailcc) {
          if (emailcc.includes(value)) {
            return true;
          }
        });
        if (!emailExists) {
          this.sendlistMailCC.push(value);
        }
      });
      let listMailCCUpdate = this.listMailCC.filter(item => {
        return (item !== '' && item !== ' ')
      })
      if (listMailCCUpdate.length !== this.listMailCC.length) {
        this.listMailCC = listMailCCUpdate
      }
    },
    listMailBCC(newVal, oldVal) {
      let listMailBCCUpdate = this.listMailBCC.filter(item => {
        return (item !== '' && item !== ' ')
      })
      if (listMailBCCUpdate.length !== this.listMailBCC.length) {
        this.listMailBCC = listMailBCCUpdate
      }
    },
  },
  beforeMount() {
    this.isFullWidthCell = (rowNode) => {
        if (this.mode == true) {
          return rowNode.data;
        }
    },
    this.fullWidthCellRenderer = (params) => {
        let to = params.data.to ? params.data.to.split(",") : null;
        if (to && to.length > 1) to = to[0] + ', ...';
        else if (to && to.length == 1) to = params.data.to;
        else to = '';
        let subject = params.data.subject || "";

        let cellClass = "cell-full-width ";
        const eDiv = document.createElement("div");
        eDiv.innerHTML = `<div class=${cellClass}>
          <div class="mail-header">
            <span>${to}</span>
            <span>${params.data.create_at}</span>
          </div>
          <br><span style="font-size:15px; line-height: 1.5">${subject}</span></div>
        </div>`;
        return eDiv.firstChild;
    };
    this.getRowHeight = () => {
      if (this.mode == true) {
        return 85;
      } else {
        return 50;
      }
    };
  },
  computed: {
    ...mapGetters({
      listMailBox: 'receiveMail/listMailBox',
      currentMailBoxSelected: 'receiveMail/currentMailBoxSelected',
      searchFilter: 'mailSentFailed/getSearchFilter',
      mode: "mailSentFailed/mode",
      listContactComputed: 'contact/getContactList',
    }),
    paginationPageSize () {
      // if (this.gridApi) return this.gridApi.paginationGetPageSize();
      // else return 10;
      return this.pagination.limit
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    totalRow(){
      return parseInt(this.pagination.totalItem)
    },
    listMailSentFailedComputed () {
      let listMailSentFailed = []
      this.listMailSentFailed.forEach((element) => {
        let parsed_body = ''
        parsed_body = element.parsed_body ? element.parsed_body.trim() : '';
        listMailSentFailed.push(Object.assign({...element,body: parsed_body}));
      });
      return listMailSentFailed
      
    },
    preview_detail() {
      return this.selectedPreviewMail ? this.selectedPreviewMail : {};
    },
    modeComputed: {
      get() {
        return this.mode;
      },
      async set() {
        await this.setMode();
      },
    },
    cleanedBodyPreviewDetail() {
        return convertLineBreakBody(this.preview_detail.body);
    },
  },
  methods: {
    ...mapActions({
      replyMail: 'moduleEmail/replyMail',
      createMail: 'moduleEmail/createMail',
      getListUserDataSelect: 'receiveMail/getListUserDataSelect',
      getListMailServerSentUser: 'receiveMail/getListMailServerSentUser',
      getListMailBox: 'receiveMail/getListMailBox',
      getListMailSentFailed: 'mailSentFailed/getListMailSentFailed',
      getListKinds: 'kinds/getListKinds',
      clearSearchFilter: 'mailSentFailed/clearSearchFilter',
      clearSearchFilterReceive: 'receiveMail/clearSearchFilter',
      setUserReadOnly: "receiveMail/setUserReadOnly",
      getListMailBoxSend: 'receiveMail/getListMailBoxSend',
      getListSettings: 'settings/getListSettings',
      setMode: "mailSentFailed/setMode",
      getSelectedMailPreviewMode: "moduleEmail/getSelectedMailPreviewMode",
      downloadFile: "receiveMail/downloadAttachment",
      fetchContactList: "contact/fetchContactList",
    }),
    ...mapMutations({
      setSearchFilter: 'mailSentFailed/SET_SEARCH_FILTER',
    }),
    setSelRange(inputEl, selStart, selEnd) {
      if (inputEl.setSelectionRange) {
        inputEl.focus();
        inputEl.setSelectionRange(selStart, selEnd);
      } else if (inputEl.createTextRange) {
        var range = inputEl.createTextRange();
        range.collapse(true);
        range.moveEnd('character', selEnd);
        range.moveStart('character', selStart);
        range.select();
      }
    },
    styleContactListDropdown(contactsDropdownId, vschipsId){
      //Start process contacts dropdown
          let concChipsTo = document.querySelector('#'+vschipsId+'>.con-chips')
          concChipsTo.style.paddingRight = '45px';
          let contactsDropdown = document.getElementById(contactsDropdownId)
          contactsDropdown.style.display = 'none';
          this.$nextTick(() => {
            contactsDropdown.style.maxHeight = '114px'
            contactsDropdown.style.overflowY = 'scroll'
          })
          let conChipsInputTo = document.querySelector('#'+vschipsId+'>.con-chips>.con-chips--input')
          conChipsInputTo.addEventListener('input', function() {
            let search = conChipsInputTo.value.toLowerCase();
            if(search != '') {
              contactsDropdown.style.display = 'block';
            } else {
              contactsDropdown.style.display = 'none';
            }
            let lists = document.querySelectorAll('#'+contactsDropdownId+'>li');
            const listsLen = lists.length;
            let totalContactsShow = 0
            for (let i = 0; i < listsLen; ++i) {
              const listContent = lists[i].textContent.toLowerCase();
              if (listContent.indexOf(search) > -1) {
                lists[i].style.display = 'block';
                totalContactsShow++
              } else {
                lists[i].style.display = 'none';
              }
            }
            if(!totalContactsShow) {
              contactsDropdown.style.display = 'none';
            }
          })

          document.addEventListener('click', function handleClickOutsideBox(event) {
            if (!contactsDropdown.contains(event.target)) {
              contactsDropdown.style.display = 'none';
              conChipsInputTo.value = '';
            }
          });

          contactsDropdown.addEventListener('click', () => {
            contactsDropdown.style.display = 'none';
            conChipsInputTo.value = '';
            conChipsInputTo.focus();
          });
          //End process contacts dropdown
    },
    pressEnterSearch() {
      this.onSearch(true)
    },
    clearInput(modelExpression) {
      this[modelExpression] = ""; // Clear the value input
    },
    clearFocusTypeDropdown() {
      this.$nextTick(() => {
        document.activeElement.blur()
        document.getElementById('mail_sent_failed_filters').focus()
      })
    },
    handleFiles(Event){
      const toBase64 = file => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
      });
      let fileInput = Object.values(Event.target.files);
      fileInput.forEach(file =>{
        if (file.size == 0){
          this.$vs.notify({
            position: 'bottom-right',
            text: file.name+'ファイル容量が0となっているので、添付できません。',
            color: 'danger'
          })
          this.$refs.files.value = '';
        } else {
          toBase64(file).then(res => {
            let maxSize = parseInt(getMaximumSizeAttachment(this.listSettings));
            if (file.size > maxSize*1024*1024) throw 'ファイル容量は'+maxSize+'MB以下でアップロードしてください。';
            let pos = res.indexOf("base64,");
            res = res.substring(pos+7);
            let fileEncode = {
              "file_name": file.name,
              "mime": file.type,
              "file_content": res,
              "size": file.size
            }
            if (!this.isDuplicateFile(fileEncode)) {
              this.files.push(fileEncode);
            }
          })
          .catch(err =>{
            this.$vs.notify({
            position: 'bottom-right',
            text: err.target ? err.target.error : err,
            color: 'danger'
          })
          this.$refs.files.value = '';
          })
        }  
      })
    },
    isDuplicateFile(fileEncode){
      return this.files.some((existingFileEncode) => {
        return existingFileEncode.file_name === fileEncode.file_name && existingFileEncode.mime === fileEncode.mime && existingFileEncode.file_content === fileEncode.file_content;
      });
    },
    removeFile(index){
      this.files.splice(index,1);
    },
    async paginationPage(value) {
      if(!this.isCreated){
        this.pagination.currentPage = value
        let mailBox = this.$route.params.email;
        if (mailBox){

        }else if (this.listMailBox && this.listMailBox.length > 0) {
          mailBox = this.listMailBox[0].receive_user_name
        }
        await this.onSearch(false, mailBox)
      }
    },
    regexMailToCCBcc(email){
      //Get the mail inside the <> sign
      const startIndex = email.indexOf('<');
      const endIndex = email.indexOf('>');
      if (startIndex !== -1 && endIndex !== -1) {
        email = email.substring(startIndex + 1, endIndex);
      }
      return email.trim();
    },
    async onSelectionChanged() {
      let selectedrow = this.gridApi.getSelectedRows()
      let indexSelectedRow = this.gridApi.getSelectedNodes()
      //Refresh list To, CC, BCC, ReplyMailID, IDMailFailed
      this.listMailTo = [];
      this.listMailCC = [];
      this.listMailBCC = [];
      this.sendlistMailTo = [];
      this.sendlistMailCC = [];
      this.replyMailID = null;
      this.idMailFailed = null;
      //Setup data detail
      if (selectedrow[0] && indexSelectedRow[0]) {
        this.idMailFailed = selectedrow[0].id;
        //handle message body
        this.canChangeMessage = false;
        this.$nextTick(() => {
            this.mailMessage = this.listMailSentFailed[indexSelectedRow[0].rowIndex].body;
            setTimeout(() => {
              if(this.mailMessage !== '') {
                if(!this.modeHTML) {
                  let lines = document.getElementById('textMessage').value.split('\n')
                  let row1 = lines[0] ? lines[0].replaceAll(/\s/g,'') : ''
                  let row2 = lines[1] ? lines[1].replaceAll(/\s/g,'') : ''
                  let row3 = lines[2] ? lines[2].replaceAll(/\s/g,'') : ''

                  if(row1.length > 0) {
                      this.mailMessage = '\n\n\n' + this.mailMessage
                  } else if (row1.length == 0 && row2.length > 0) {
                      this.mailMessage = '\n\n' + this.mailMessage
                  } else if (row1.length == 0 && row2.length == 0 && row3.length > 0) {
                      this.mailMessage = '\n' + this.mailMessage
                  }
                }
                this.prependBrBasedOnContentHTML();
              }
            }, 10)
            if(!this.modeHTML) {
              setTimeout(() => {
                var pos = 2
                this.setSelRange(document.getElementById('textMessage'), pos, pos)
              }, 20)
            }
          })
        await this.setModeHTML(selectedrow[0]);
        this.inquiryType = {
          label : selectedrow[0].inquiry_type_text,
          value : selectedrow[0].inquiry_type
        }
        this.type = {
          label : selectedrow[0].kinds_name,
          value : selectedrow[0].kinds_state
        }
        this.mst_user = {
          label : selectedrow[0].full_name,
          value : selectedrow[0].mst_user_id
        }
        this.mailFrom = selectedrow[0].email_sender;
        if(selectedrow[0].to){
          let dataMailTo = selectedrow[0].to.split(',');
          dataMailTo.forEach(to => {
            const emailTo = this.regexMailToCCBcc(to);
            this.listMailTo.push(emailTo);
          });
        }
        if(selectedrow[0].cc){
          let dataMailCC = selectedrow[0].cc.split(',');
          dataMailCC.forEach(cc =>{
            const emailCC = this.regexMailToCCBcc(cc);
            this.listMailCC.push(emailCC);
          });
        }
        this.sendlistMailTo = selectedrow[0].to  ? selectedrow[0].to.split(',') : []
        this.sendlistMailCC = selectedrow[0].cc  ? selectedrow[0].cc.split(',') : []
        this.listMailBCC = selectedrow[0].bcc  ? selectedrow[0].bcc.split(',') : []
        this.mailSubject = selectedrow[0].subject;
        this.errorDetail = selectedrow[0].error_detail;
        this.replyMailID = selectedrow[0].receive_mail_id;
        this.activePopUp = true;
        this.canChangeMessage = true;
      }
      
    },
    onSortChanged(event) {
      let columns = event.columnApi.getAllColumns();
      let root = this
      columns.forEach(function(column) {
        if (column.getSort()){
          root.orderDir = column.getSort()
          root.orderBy = column.getColId()
          root.onSearch(false)
        }
      })
    },
    updateSortParams(orderBy, orderDir) {
      this.orderBy = orderBy
      this.orderDir = orderDir
    },
    async getListMstUserSelect() {
      let mailBoxInfo = await this.listMailBox.find(element => element.receive_user_name == this.currentMailBoxSelected)
      if (mailBoxInfo) {
        let params = {
          'mst_mail_server_id': mailBoxInfo.id
        }
        let response = await this.getListUserDataSelect(params)
        if (response) {
          this.listMstUserSelect = [
            {
              label: '...',
              value: ''
            }
          ]
          response.map(element => {
            let result = { }
            result.value = element.id
            result.label = element.full_name
            this.listMstUserSelect.push(result)
          })
        } else {
          this.listMstUserSelect = [
            {
              label: '...',
              value: ''
            }
          ]
        }
      }

    },
    async onSearch(resetPaging, mailBox = null) {
      let mst_user_id = ''
      if (this.checkIsMultiple.mst_user) {
        if (this.mst_user_search && this.mst_user_search.length && this.mst_user_search.length > 0) {
          mst_user_id = this.mst_user_search
        }
      } else {
        if (this.mst_user_search) {
          mst_user_id = this.mst_user_search.value
        }
      }
      let state_flg = ''
      if (this.checkIsMultiple.state_flg) {
        if (this.state_flg_search && this.state_flg_search.length && this.state_flg_search.length > 0) {
          state_flg = this.state_flg_search
        }
      } else {
        if (this.state_flg_search) {
          state_flg = this.state_flg_search.value
        }
      }
      let mail_type = ''
      if (this.mail_type_search) {
        mail_type = this.mail_type_search.value
      }
      let inquiry_type = ''
      if (this.inquiry_type_search) {
        inquiry_type = this.inquiry_type_search.value
      }
      let type = ''
      if (this.checkIsMultiple.type) {
        if (this.type_search && this.type_search.length && this.type_search.length > 0) {
          type = this.type_search
        }
      } else {
        if (this.type_search) {
          type = this.type_search.value
        }
      }
      let action = ''
      if (resetPaging === true && mailBox === null) {
        action = 'search'
      }
      if (mailBox === null) {
        mailBox = this.currentMailBoxSelected
      } else {
        this.$store.commit('receiveMail/SET_CURRENT_MAIL_BOX_SELECT', mailBox)
      }
      // process order by
      if (this.orderBy) {
        if (this.orderBy === 'state_flg_text') {
          this.orderBy = 'state_flg'
        }
        if (this.orderBy === 'inquiry_type_text') {
          this.orderBy = 'inquiry_type'
        }
        if (this.orderBy === 'type_text') {
          this.orderBy = 'type'
        }
      }
      let page = this.pagination.currentPage
      if(resetPaging === true) page = 1
      if(this.isCreated) page = this.searchFilter && this.searchFilter.mailBox === mailBox ? this.searchFilter.queries.page : 1 
      let params = {
        mailBox: mailBox,
        queries: {
          error: true,
          inquiry_type: inquiry_type,
          sent_datetime: this.sent_date_search,
          mail_type: mail_type,
          receive_mail_id: this.receive_mail_id_search,
          mst_user_id: mst_user_id,
          state_flg: state_flg,
          subject: this.subject_search,
          body: this.body_search,
          type: type,
          action: action,
          page: page,
          limit: this.pagination.limit,
          orderBy: this.orderBy,
          orderDir: this.orderDir,
        }
      }
      let data = await this.getListMailSentFailed(params)
      this.listMailSentFailed = data.data.length > 0 ? data.data : [];
      this.setSearchFilter(params)

      this.pagination.totalItem = data.page.total;
      this.pagination.totalPage = data.page.last_page;
      this.pagination.currentPage = data.page.current_page;
      this.pagination.limit = data.page.per_page;
      this.pagination.from = data.page.from;
      this.pagination.to = data.page.to;

      //Load preview mode
      if (this.mode) setTimeout(()=> {this.loadPreview(),0});
    },
    clearSearchOption() {
      this.mail_type_search = ''
      this.clearSearchCommon()
    },
    setDefaultSearchOption() {
      this.clearSearchCommon()
    },
    clearSearchCommon() {
      this.sent_date_search = ''
      this.receive_mail_id_search = ''
      this.inquiry_id_search = ''
      this.mst_user_search = ''

      this.inquiry_type_search = {
        value: '',
        label: '...'
      }
      this.state_flg_search = {
        value: '',
        label: '...'
      }
      this.type_search = {
        value: '',
        label: '...'
      }
      this.subject_search = ''
      this.body_search    = ''
        //CheckMultiple v-Select
      this.checkIsMultiple = {
        state_flg: false,
        mst_user : false,
        type     : false,
      }
    },
    async getListKindsSelect() {
      let response = await this.getListKinds()
      if (response) {
        
        this.listTypeSelect = [
              {
                label: '...',
                value: ''
              }
        ]
        response.map(element => {
          let result = { }
          result.value = element.type_id
          result.label = element.kinds_name
          this.listTypeSelect.push(result)
        })
      } else {
        this.listTypeSelect = [
            {
              label: '...',
              value: ''
            }
        ]
      }
    },
    async resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.clearSearchFilter()
      this.clearSearchOption()
      await this.onSearch(true)
      this.$refs.filterCard.removeRefreshAnimation()
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      if (this.mode) {
        this.loadPreview();
      }
    },
    onGridReadyState(params) {
      this.gridApiState = params.api 
      this.columnApiState = params.columnApi
    },
    mailBoxSelectable(){
      let mailBox = this.listMailBox.find(item => item.receive_user_name === this.$route.params.email)
      if(!mailBox.numberMailNotSupport) document.getElementsByClassName('ag-header-select-all ag-labeled ag-label-align-right ag-checkbox')[0].style.opacity = '0.5'
      else document.getElementsByClassName('ag-header-select-all ag-labeled ag-label-align-right ag-checkbox')[0].style.opacity = '1'
    },
    selectionChangedvSelect(){
      if (this.state_flg_search && this.state_flg_search.length >= 0) {
        if (this.state_flg_search.includes('') || this.state_flg_search.length == 0) {
          this.state_flg_search = [];
        }
      }
      if (this.mst_user_search && this.mst_user_search.length >= 0) {
        if (this.mst_user_search.includes('') || this.mst_user_search.length == 0) {
          this.mst_user_search = [];
        }
      }
      if (this.type_search && this.type_search.length >= 0) {
        if (this.type_search.includes('') || this.type_search.length == 0) {
          this.type_search = [];
        }
      }
      setTimeout(() => this.checkSelected(), 0);
    },
    openvSelect(){
      if (!this.checkIsMultiple.state_flg) {
        this.checkIsMultiple.state_flg = true;
      }
      if (!this.checkIsMultiple.mst_user) {
        this.checkIsMultiple.mst_user = true;
      }
      if (!this.checkIsMultiple.type) {
        this.checkIsMultiple.type = true;
      }
      setTimeout(() => this.checkSelected(), 0);
    },
    checkSelected() {
      let mst_user    = document.querySelectorAll('#mst_user_search>ul>li');
      let state_flg   = document.querySelectorAll('#state_flg_search>ul>li');
      let type_search = document.querySelectorAll('#type_search>ul>li');
      if (mst_user && mst_user.length > 0) {
        mst_user.forEach((element)=>{
        let className = element.getAttribute('class');
        //Check exist element <b>
        let check = element.querySelector('li>b');
        if (check) {
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        } else {
          //Create element <b> if not exist
          let check = document.createElement('b');
          check.textContent = "✓"
          element.prepend(check)
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        }
        })
      }
      if (state_flg && state_flg.length > 0) {
        state_flg.forEach((element)=>{
        let className = element.getAttribute('class');
        //Check exist element <b>
        let check = element.querySelector('li>b');
        if (check) {
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        } else {
          //Create element <b> if not exist
          let check = document.createElement('b');
          check.textContent = "✓"
          element.prepend(check)
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        }
        })
      }
       if (type_search && type_search.length > 0) {
        type_search.forEach((element)=>{
        let className = element.getAttribute('class');
        //Check exist element <b>
        let check = element.querySelector('li>b');
        if (check) {
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        } else {
          //Create element <b> if not exist
          let check = document.createElement('b');
          check.textContent = "✓"
          element.prepend(check)
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        }
        })
      }
      
    },
    validateEmail(email) {
      if (email.length > 0) {
        email = email.trim()
      }
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },
    //Process message body
    async setModeHTML(mailSent){
      if (mailSent.body_type){
        this.modeHTML = mailSent.body_type == 0;
      } else{
        this.modeHTML = true;
      }
    },
    changeModeHTML(){
      if (this.modeHTML){
        if (this.mailMessage == '') this.modeHTML = false;
        else this.activeChangeModeHTML = true;
      } else{
        this.modeHTML = true;
      }
    },
    onEditorInit(editor) {
        this.tinymceEditor = editor;
        editor.off('KeyUp');
        this.prependBrBasedOnContentHTML();
    },
    prependBrBasedOnContentHTML() {
        if (!this.tinymceEditor) return;
        if (this.modeHTML) {
            const content = this.tinymceEditor.getContent();
            const doc = new DOMParser().parseFromString(content, 'text/html');

            let lines = doc.body.innerHTML.split(/<br\s*\/?>|<p>&nbsp;<\/p>/gi).map(line =>
                line.replace(/<[^>]*>/g, '').replace(/\s/g, '')
            );

            let row1 = lines[0] || '';
            let row2 = lines[1] || '';
            let row3 = lines[2] || '';

            if (row1.length > 0) {
                this.mailMessage = ' <br><br><br>' + this.mailMessage
            } else if (row1.length == 0 && row2.length > 0) {
                this.mailMessage = '<br><br>' + this.mailMessage
            } else if (row1.length == 0 && row2.length == 0 && row3.length > 0) {
                this.mailMessage = '<br>' + this.mailMessage
            }
        }
        this.$nextTick(() => {
            focusAtBrLine(this.tinymceEditor,this.$route.name);
        });
    },
    changeMessage(){
      if(!this.modeHTML){
        this.mailMessage = this.mailMessage.replace(/<!--\[if\s+mso\]>[\s\S]*?<!\[endif\]-->/gi, '')
          .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        this.mailMessage = this.mailMessage.split('<br />').join("<br>\n")
        this.mailMessage = this.mailMessage.split('<p><span>').join("<p>").split('</span></p>').join("</p>")
        this.mailMessage = this.mailMessage.split('<p><br>').join("\n")
        this.mailMessage = this.mailMessage.split(' </p>').join("</p>")
        this.mailMessage = this.mailMessage.split('&nbsp;&nbsp;</p>').join("</p>")
        this.mailMessage = this.mailMessage.split('&nbsp;</p>').join("</p>")
        this.mailMessage = this.mailMessage.split(/<\/p>\s*<p[^>]*>/gi).join("</p><p>")
        this.mailMessage = this.mailMessage.split('&nbsp;\n').join("\n")
        this.mailMessage = htmlToFormattedText(this.mailMessage)
        this.mailMessage ='\n\n\n'+ Html5Entities.decode(this.mailMessage)
        this.$nextTick(() => {
          let textMess  = document.getElementById('textMessage')
          textMess.selectionStart = 2;
          textMess.selectionEnd = 2;
          textMess.focus();
        });
      }else{
        this.mailMessage = Html5Entities.encode(this.mailMessage)
        this.mailMessage = this.mailMessage.split('\n')
        this.mailMessage = this.mailMessage.join('\n<br/>')
        this.mailMessage = this.mailMessage.split(' ')
        this.mailMessage = this.mailMessage.join('&nbsp;')
        focusAtBrLine(this.tinymceEditor, this.$route.name);
      }
    },
    async validateForm() {
      // Email To is required
      if(this.listMailTo.length == 0 && this.mailTo == ''){
        this.messageError = 'Toは必須です。'
        return false
      }

      // validateEmail in listMail
      if(this.listMailTo.length > 0){
        let to = this.listMailTo.find(to => this.validateEmail(to) == false)
        if(to) {
          this.messageError = 'メールアドレス形式が正しくありません。'
          return false
        }
      }
      if(this.listMailCC.length > 0){
        let cc = this.listMailCC.find(cc => this.validateEmail(cc) == false)
        if(cc){
          this.messageError = 'メールアドレス形式が正しくありません。'
          return false
        }
      }
      if(this.listMailBCC.length > 0){
        let bcc = this.listMailBCC.find(bcc => this.validateEmail(bcc) == false)
        if(bcc){
          this.messageError = 'メールアドレス形式が正しくありません。'
          return false
        }
      }

      // validateEmail on input: if not press 'enter' to add listMail
      if(this.mailTo && !this.validateEmail(this.mailTo)) {
        this.messageError = 'メールアドレス形式が正しくありません。'
        return false
      }
      if(this.mailCC && !this.validateEmail(this.mailCC)){
        this.messageError = 'メールアドレス形式が正しくありません。'
        return false
      }
      if(this.mailBCC && !this.validateEmail(this.mailBCC)){
        this.messageError = 'メールアドレス形式が正しくありません。'
        return false
      }
      if (!this.inquiryType || (this.inquiryType && this.inquiryType.label == "...")) {
        this.messageError = '方法をご選択ください。'
        return false
      }
      if (!this.type || (this.type && this.type.value == "")) {
        this.messageError = '種別をご選択ください。'
        return false
      }
      if (!this.mst_user || (this.mst_user && this.mst_user.value == "")) {
        this.messageError = '担当者をご選択ください。'
        return false
      }
      if (this.mailSubject.length > 512) {
        this.messageError = '件名は512文字以下で指定ください。'
        return false
      }

      this.messageError = ''
      return true
    },
    async beforeSendMail () {
      let validate = await this.validateForm();
      if(!validate){
        this.$vs.notify({
          position: 'bottom-right',
          text: this.messageError,
          color: 'danger'
        })
      }
      else{
        this.totalConfirmTime = 0
        if (this.mailSubject && this.mailMessage) {
          await this.reSend();
        } else {
          if (!this.mailSubject) {
            this.totalConfirmTime++
          }
          if (!this.mailMessage) {
            this.totalConfirmTime++
          }
          this.confirmDialogBeforeSend()
        }
      }
    },
    confirmDialogBeforeSend() {
      if(!this.mailSubject){
        this.confirmQuestionSend = '件名内容なしでメール送信しますか？'
        this.titleDialogSend = '件名内容確認'
        this.activeSend = true
      }
      else if(!this.mailMessage){
        this.confirmQuestionSend = '返信内容なしでメール送信しますか？'
        this.titleDialogSend = '返信内容確認'
        this.activeSend = true
      }
    },
    async confirm() {
      this.totalConfirmTime--
      if (this.totalConfirmTime === 0) {
        await this.reSend();
      }
      if(this.totalConfirmTime > 0) {
        this.confirmQuestionSend = '返信内容なしでメール送信しますか？'
        this.titleDialogSend = '返信内容確認'
        this.activeSend = true
      }
    },
    async reSend() {
      let listTo = this.listMailTo.map(mail => mail)
      if(this.mailTo) {
        listTo.push(this.mailTo)
      } 
      let listCC = this.listMailCC.map(mail => mail)
      if(this.mailCC) {
        listCC.push(this.mailCC)
      } 
      let listBCC = this.listMailBCC.map(mail => mail)
      if(this.mailBCC) {
        listBCC.push(this.mailBCC)
      }
      let listSendTo = this.sendlistMailTo.map(mail => mail)
      if(this.mailTo) {
        listSendTo.push(this.mailTo)
      } 
      let listSendCC = this.sendlistMailCC.map(mail => mail)
      if(this.mailCC) {
        listSendCC.push(this.mailCC)
      } 
      
      // set data send
      let mailData = {
          id  : this.idMailFailed,
          body_type    : this.modeHTML ? 'HTML':'Text',
          to      : listTo,
          from    : this.mailFrom,
          subject : this.mailSubject,
          body    : this.mailMessage,
          cc      : listCC,
          bcc     : listBCC,
          files   : this.files,
          inquiry_type: this.inquiryType.value,
          type : this.type.value,
          mst_user_id: this.mst_user.value,
          newTo  : listSendTo ? listSendTo : [],
          newCC  : listSendCC ? listSendCC : [],
        }
      let success
      if (this.replyMailID) {
        mailData.mail_id = this.replyMailID;
        success = await this.replyMail(mailData);
      } else {
        success = await this.createMail(mailData);
      }
      if (success){
        this.activePopUp = false;
        await this.onSearch(false);
      }
    },
    async onPreviewModeSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      let params = {
        mailBox: this.$route.params.email,
        id: selectedRows[0].id,
        type: 1
      }
      let selectedPreviewMail = await this.getSelectedMailPreviewMode(params);
      selectedPreviewMail.inquiry_type_text = convertInquiryTypeToText(selectedPreviewMail.inquiry_type)
      selectedPreviewMail.type_text = convertMailTypeToText(null, selectedPreviewMail.kinds_name, selectedPreviewMail.kinds_state)
      selectedPreviewMail.mst_user = selectedRows[0].full_name
      selectedPreviewMail.attachmentFileName = [];
      if (selectedPreviewMail.attachment_filepath){
        let listattachmentFiles = selectedPreviewMail.attachment_filepath.split(',')
        listattachmentFiles.forEach((element)=>{
        selectedPreviewMail.attachmentFileName.push({
            path: element,
            file_name: element.split('/').reverse()[0]
          })
        });
      }
      this.selectedPreviewMail = selectedPreviewMail;
      if(this.preview_detail.body_type) {
        const topScrollElement = document.getElementById('previewDetailBodyTextarea')
        topScrollElement.scrollTop = 0;
      }
      else {
        const topScrollElement = document.getElementById('previewDetailBodyBlock')
        topScrollElement.scrollTop = 0;
      }
    },
    loadPreview() {
      if (this.selectedPreviewMail) {
        let isNewPage = true;
        this.gridApi.forEachNode((node) => {
          isNewPage =
            this.selectedPreviewMail.id == node.data.id ? false : isNewPage;
          node.setSelected(
            this.selectedPreviewMail.id == node.data.id,
            true,
            true
          ); //Prevent call back to onPreviewModeSelectionChanged
        });
        //Set node[0] when direct to new page
        if (isNewPage && this.gridApi.getRowNode(0)) this.gridApi.getRowNode(0).setSelected(true);
        else if (this.listMailSentFailed && this.listMailSentFailed.length == 0) this.selectedPreviewMail = {};
      } else {
        this.gridApi.getRowNode(0).setSelected(true);
      }
    },
    async downloadAttachment(file) {
      let data = {
        "id" : this.preview_detail.id,
        "fileName" : file,
      }
      let result = await this.downloadFile(data);
      if (result) {
        handleDownloadAttachment(result);
      }
    },
    async editMailDetail() {
      this.activePreviewPopUp = true;
      await this.onSelectionChanged();
    },
    contactSelected(contact,typeContact) {
      if (typeContact === 'TO') {
        this.listMailTo = this.removeDuplicates([...this.listMailTo, contact]);
        this.sendlistMailTo = this.removeDuplicates([...this.sendlistMailTo, contact]);
      } else if (typeContact === 'CC') {
        this.listMailCC = this.removeDuplicates([...this.listMailCC, contact]);
        this.sendlistMailCC = this.removeDuplicates([...this.sendlistMailCC, contact]);
      } else if (typeContact === 'BCC') {
        this.listMailBCC = this.removeDuplicates([...this.listMailBCC, contact]);
      }
    },
    showListContact(type) {
      this.$nextTick(() => {
        this.activeModelContacts = true
        this.typeModalContact = type;
      });
    },
    removeDuplicates(array) {
      return array.filter((item, index) => array.indexOf(item) === index);
    }
  },
  mounted () {
    //Start process contacts dropdown
    this.styleContactListDropdown('contacts_dropdown',"vschipsTo");
    this.styleContactListDropdown('contacts_dropdown_cc',"vschipsCc");
    this.styleContactListDropdown('contacts_dropdown_bcc',"vschipsBcc");
    //End process contacts dropdown

    this.gridApi = this.gridOptions.api
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    this.mailBoxSelectable()
    this.clearSearchFilterReceive()
    // addEventListener Reload => clear
    window.addEventListener('beforeunload', this.resetColFilters)
    const root = this;
    for(let index = 0; index < document.getElementsByClassName('con-chips--input').length; index++){
      document.getElementsByClassName('con-chips--input')[index].addEventListener('input', function() {
        let valueInput = document.getElementsByClassName('con-chips--input')[index].value
        if (valueInput.length > 0) {
          valueInput = valueInput.trimStart()
          // valueInput = valueInput.replaceAll('\t','')
          document.getElementsByClassName('con-chips--input')[index].value = valueInput
        }
        if(index == 0){
          root.mailTo = document.getElementsByClassName('con-chips--input')[index].value
        }
        if(index == 1){
          root.mailCC = document.getElementsByClassName('con-chips--input')[index].value
        }
        if(index == 2){
          root.mailBCC = document.getElementsByClassName('con-chips--input')[index].value
        }
      });
    }
    for(let index = 0; index < document.getElementsByClassName('con-chips--input').length; index++){
      document.getElementsByClassName('con-chips--input')[index].addEventListener('blur', function() {
        let valueInput = document.getElementsByClassName('con-chips--input')[index].value
        if (valueInput.length > 0) {
          valueInput = valueInput.trim()
          // valueInput = valueInput.replaceAll('\t','')
          document.getElementsByClassName('con-chips--input')[index].value = valueInput
        }
        if(index == 0){
          root.mailTo = document.getElementsByClassName('con-chips--input')[index].value
        }
        if(index == 1){
          root.mailCC = document.getElementsByClassName('con-chips--input')[index].value
        }
        if(index == 2){
          root.mailBCC = document.getElementsByClassName('con-chips--input')[index].value
        }
      });
    }
    EventBus.$on("applyContactsTo", (listMailToSelected,typeModalContact) => {
      const regexMail = /<([^<>]+?)>/;
      let listSelectedMail = listMailToSelected.map(email => regexMail.exec(email)[1]);
      if (typeModalContact === 'TO') {
        this.listMailTo = this.removeDuplicates([...this.listMailTo, ...listSelectedMail]);
        this.sendlistMailTo = this.removeDuplicates([...this.sendlistMailTo, ...listMailToSelected]);
      } else if (typeModalContact === 'CC') {
        this.listMailCC = this.removeDuplicates([...this.listMailCC, ...listSelectedMail]);
        this.sendlistMailCC = this.removeDuplicates([...this.sendlistMailCC, ...listMailToSelected]);
      } else if (typeModalContact === 'BCC') {
        this.listMailBCC = this.removeDuplicates([...this.listMailBCC, ...listSelectedMail]);
      }
    });
    EventBus.$on("disableModelContacts", () => {
      this.activeModelContacts = false
    });
    setupIconClickEvent();
    setupLanguageTinymce();
  },
  async created () {
    if(this.$route.meta.isShowIConContact) {
      this.showIconContacts = true
    }
    await this.fetchContactList()
    /* start loading with many requests */
    this.$store.dispatch('updateLoads', true)

    let mailBox = this.$route.params.email;
    await this.getListMailBox()
    if(!mailBox){
      if (this.listMailBox && this.listMailBox.length > 0){
        mailBox = this.listMailBox[0].receive_user_name
      }
    }
    else{
      if(this.listMailBox && this.listMailBox.length > 0 && this.listMailBox.find(mb => mb.receive_user_name == mailBox)){
        //...
      }
      else  mailBox = null
    }
    await this.getListMstUserSelect()
    await this.getListKindsSelect()
    if (mailBox) {
      this.gridApi.sizeColumnsToFit();
      if(this.searchFilter && this.searchFilter.queries && this.searchFilter.mailBox && this.searchFilter.mailBox === mailBox){
        this.subject_search = this.searchFilter.queries.subject ? this.searchFilter.queries.subject : ''
        this.body_search = this.searchFilter.queries.body ? this.searchFilter.queries.body : ''
        this.mail_type_search = this.listMailTypeSelect.find(type => type.value === this.searchFilter.queries.mail_type)
        this.inquiry_type_search = this.listInquiryTypeSelect.find(inquiry => inquiry.value === this.searchFilter.queries.inquiry_type)
        this.mst_user_search = this.listMstUserSelect.find(user => user.value === this.searchFilter.queries.mst_user_id)
        this.email_sender_search = this.searchFilter.queries.email_sender ? this.searchFilter.queries.email_sender : '...'
        this.type_search = this.listTypeSelect.find(type => type.value === this.searchFilter.queries.type)
        this.state_flg_search = this.listSendMailSelectStateFlag.find(state => state.value === this.searchFilter.queries.state_flg)
        this.pagination.limit = this.searchFilter.queries.limit ? this.searchFilter.queries.limit:10
        this.sent_date_search = this.searchFilter.queries.sent_datetime ? this.searchFilter.queries.sent_datetime : ''
        this.orderBy = this.searchFilter.queries.orderBy ? this.searchFilter.queries.orderBy : 'receive_datetime'
        this.orderDir = this.searchFilter.queries.orderDir ? this.searchFilter.queries.orderDir : 'asc'
      }
      this.readOnly = await this.setUserReadOnly(mailBox) > 0;
      if (!this.readOnly){
        const listMailBox = await this.getListMailBoxSend();
        listMailBox.filter( item =>{
          this.listMailFrom.push(item.sent_user_name);
        })
        const setting = await this.getListSettings();
        if (setting){
          this.listSettings = [];
          setting.map(element => this.listSettings.push(element));
        }
      }
      await this.onSearch(false, mailBox)
      this.isCreated = false
    }
    else this.$router.push({ path: '/dashboard'})
    
    /* stop loads */
    this.$store.dispatch('updateLoads', false)
  },
  updated () {
    this.$nextTick(()=>{
      if(!this.$store.state.loading && this.listMailSentFailed.length > 0){
        this.startRow = this.pagination.currentPage * this.pagination.limit - this.pagination.limit + 1
        if(this.listMailSentFailed.length == this.pagination.limit) this.endRow = this.pagination.currentPage*this.pagination.limit
        else this.endRow = this.pagination.limit*this.pagination.currentPage + this.listMailSentFailed.length - this.pagination.limit
      }
      else if(this.listMailSentFailed.length == 0){
        this.pagination.totalItem = 0;
        this.startRow = 0
        this.endRow = 0
      }
    });
    this.mailBoxSelectable()
  },
  beforeDestroy(){
    window.removeEventListener('beforeunload', this.resetColFilters, {passive: true})
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/mailSentFailed.scss";
@import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
.div-show-receive-mail{
  position: relative !important;
  .vs--single.vs--loading .vs__selected, .vs--single.vs--open .vs__selected {
    position: relative !important;
  }
  .v-select {
    border-radius: 6px;
    width: 120px;
    color : #ffffff;
    position: absolute !important;
    top: 0;
    z-index: 56000 !important;
    right: 0;
    .vs__dropdown-toggle{
      border-radius: 6px !important;
      height: 40px;
      background-color: darkgray;
      color : #ffffff;
      .vs__selected{
        color : #ffffff;
       margin-top: 0 !important;
      }

    }
    #vs1__listbox li {
      padding: 15px ;
    }
  }
  .text-Message {
    #textMessage{
      border: none !important;
      border-top: 1px solid rgba(0, 0, 0, 0.2) !important;
      border-radius: 0px;
      margin-top: 40px;
      font-size: 13px !important;
      padding: 15px;
      padding-top: 12px;
      font-family: Helvetica, Arial, sans-serif !important;
      line-height: 1.42 !important;
    }
  }
  #tinymceMessageSendFailed {
    width: 100% !important;
    .tox-tinymce {
      min-height: 260px;
      .tox-tbtn--select {
        max-width: 93px !important;
      }
      .tox-editor-container {
        background: #fff !important;
        .tox-toolbar {
          background: none !important;
        }
        .tox-sidebar-wrap {
          border-top: 1px solid #cccc;
        }
        .tox-editor-header {
          width: 90% !important;
        }
      }
      .tox-statusbar {
        border: none !important;
        .tox-statusbar__text-container {
          display: none !important;
        }
      }
    }
  }
}

.contact-li {
  font-size: 15px;
  padding: 3px 10px;
  &:hover {
    background-color: #5897fb;
  }
}
#contacts_dropdown {
  /* width */
  &::-webkit-scrollbar {
    width: 7px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.vschipsContacts {
  .con-chips{
      padding-right: 45px;
    .con-chips--remove-all {
      display: none;
    }
  }
}

.vs-con-input .icon-after {
  right: 7px;
  top: 10px;
  border: none;
  cursor: pointer;
}
.tox {
  z-index: 55000 !important;
}
</style>
